import { render, staticRenderFns } from "./CartInit.vue?vue&type=template&id=55ded5c6&lang=pug&"
import script from "./CartInit.vue?vue&type=script&lang=js&"
export * from "./CartInit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/buddy/dashing-diva/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('55ded5c6')) {
      api.createRecord('55ded5c6', component.options)
    } else {
      api.reload('55ded5c6', component.options)
    }
    module.hot.accept("./CartInit.vue?vue&type=template&id=55ded5c6&lang=pug&", function () {
      api.rerender('55ded5c6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/scripts/components/cart/CartInit.vue"
export default component.exports